import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'empty-new-page',
  templateUrl: './empty-new-page.component.html',
  styleUrls: ['./empty-new-page.component.scss']
})
export class EmptyNewPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
